import {
  Center,
  Container,
  Grid,
  Loader,
  MediaQuery,
  Tabs,
  useMantineTheme,
} from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import useUserInfo from '@/api/useUserInfo';
import { TopMenu } from '@/components/TopMenu';
import { useGlobalStore } from '@/store/global';

import { AccountAddresses } from '../components/AccountAddresses';
import { AccountDetails } from '../components/AccountDetails';

export const MyAccount = () => {
  const theme = useMantineTheme();
  const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.md}px)`);
  const navigate = useNavigate();
  const { state } = useLocation();
  const { reset } = useGlobalStore();
  const { error, isLoading } = useUserInfo();

  useEffect(() => {
    if (isLoading) return;
    if (error) {
      reset();
      navigate('/auth', { state });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error, isLoading]);

  const handleLogout = () => {
    reset();
    navigate('/auth');
  };

  // eslint-disable-next-line no-constant-condition
  if (isLoading)
    return (
      <Center style={{ width: '100vw', height: '100vh' }}>
        <Loader color="dark" />
      </Center>
    );

  return (
    <>
      <TopMenu />
      <Container size="xl">
        <MediaQuery
          smallerThan="md"
          styles={{
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
          }}
        >
          <Grid
            columns={12}
            pt={isDesktop ? '100px' : '88px'}
            pb={isDesktop ? '100px' : '24px'}
            px={isDesktop ? '100px' : '16px'}
          >
            <Grid.Col md={12}>
              <Tabs
                style={{ overflow: 'auto' }}
                color="dark"
                variant="pills"
                orientation={isDesktop ? 'vertical' : 'horizontal'}
                defaultValue="info"
              >
                <Tabs.List
                  style={{
                    minWidth: isDesktop ? 220 : undefined,
                    marginBottom: isDesktop ? 0 : 16,
                  }}
                >
                  <Tabs.Tab value="info">Detalhes da conta</Tabs.Tab>
                  <Tabs.Tab value="addresses">Endereços</Tabs.Tab>
                  <Tabs.Tab
                    onClick={handleLogout}
                    value="logout"
                    style={{ color: '#e03131' }}
                  >
                    Sair
                  </Tabs.Tab>
                </Tabs.List>

                <Tabs.Panel value="info" pl={isDesktop ? 'xl' : 0}>
                  <AccountDetails />
                </Tabs.Panel>

                <Tabs.Panel value="addresses" pl={isDesktop ? 'xl' : 0}>
                  <AccountAddresses />
                </Tabs.Panel>
              </Tabs>
            </Grid.Col>
          </Grid>
        </MediaQuery>
      </Container>
    </>
  );
};
